/* eslint-disable operator-linebreak */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import HighChartGraph, { ApiHandler as HC, HighChartOptions } from 'wdna-highchart';
import { emptyData, getDateFormat } from 'wdna-components/lib/helpers/highchart';

import pressets from './pressets';

type Graph = {
  data: any[];
}

interface Props {
  formValues: {
    update: string;
    multiple: boolean;
    graphInput: Graph;
  };
}

type State = unknown;

export default class Chart extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  public shouldComponentUpdate = (nextProps: Props): boolean => {
    return this.props.formValues.update !== nextProps.formValues.update;
  };

  public getOptions = (graphInput: any = {}): any => {
    const { groupDateTime } = graphInput;
    const dateFormat: any = getDateFormat(groupDateTime);
    const { axisX } = dateFormat;

    const options: HighChartOptions = _.cloneDeep(pressets.line);
    const hc: HC = new HC(options);
    hc.setXAxisFormat(axisX);

    return options;
  };

  public render(): JSX.Element {
    const { graphInput, multiple } = this.props.formValues;
    const { data } = graphInput || {};
    const options: any = this.getOptions();

    let hgList: JSX.Element[] | JSX.Element = <HighChartGraph data={emptyData} options={options} settings />;
    let style: React.CSSProperties = { height: 'calc(75vh)' };
    if (data) {
      if (multiple) {
        style = {};
        hgList = data.map((d: any): JSX.Element => {
          return (
            <div key={d.name}>
              <HighChartGraph data={[d] || emptyData} options={options} settings />
            </div>
          );
        });
      } else {
        hgList = <HighChartGraph data={data || emptyData} options={options} settings />;
      }
    }

    return <div style={style}>{hgList}</div>;
  }
}
